var Model = require("../types/Model.js");

module.exports = new Model({
	name: "reading",
	init,
	uninit,
	triggers
});

const SECTION_TO_NAME = {
	"activity": "activity",
	"bloodsugar": "blood sugar",
	"weight": "weight",
	"bloodpressure": "blood pressure",
	"bloodoxygen": "blood oxygen",
	"bodytemperature": "body temperature",
};

function init() {
	this.push({
		open: false,
		deviceType: null
	});
}

function uninit() {
	this.push({
		open: false,
		deviceType: null
	});
}

function triggers() {
	return {
		"open": open,
		"close": hide,
	};
}

function open(type){
	this.extend({
		open: true,
		deviceType: type
	});
	this.emit("usermetrics:trigger:track", `open ${SECTION_TO_NAME[type]} section as basic user`);
}

function hide(cancelled){
	cancelled && this.emit("usermetrics:trigger:track", `close ${SECTION_TO_NAME[this.data.deviceType]} section as basic user`);
	this.extend({
		open: false
	});
}